var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLmax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 23,
    viewBox: "0 0 103 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2423_25630",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00830078 0.108398H73.8343V22.3809H0.00830078V0.108398Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2423_25630)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64316 0.262695V15.7931H17.8677V22.3708H0V0.262695H7.64316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5033 0.262695L33.0604 7.73283L37.6189 0.262695H45.4909V22.3708H37.8798V12.0396L33.1615 19.3322H32.8355L28.118 12.0385V22.3708H20.6309V0.262695H28.5033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0722 0.108398H64.5308L73.8344 22.3809L65.5546 22.3711L64.4044 19.4558H57.0436L55.9246 22.3711H47.7517L57.0722 0.108398ZM60.7382 9.35999L59.0176 13.9298H62.4608L60.7382 9.35999Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9198 0L87 4.30904L91.5382 11L99 0H89.9198Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99 22L91.4156 11L87 17.4113L90.1663 22H99Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 22L82.6251 10.7722L75.3139 0H83.6913L91 10.7721L83.3745 22H75Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8268 0H75.3028L82.4785 10.776L75 22H83.5211L91 10.776L83.8268 0ZM83.6315 0.37451L90.5552 10.7758L83.326 21.6255H75.6945L82.9232 10.7761L75.9969 0.37451H83.6315Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C2.19159 12.0496 4.77974 11.2654 7 10.8611V0H0V13Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9998 8.51436L28.2739 1H21V9.96277C29.931 8.8835 38.7576 9.2754 45 10V1H37.8075L32.9998 8.51436Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4565 1L53 11.3113C54.9337 11.6364 56.9355 11.7123 59.6255 11.9574L60.908 8.65708L62.2027 11.985C64.5567 12.0661 66.4928 11.8084 69 11.438L64.4871 1H57.4565Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4598 1L88 4.81926L90.0427 8C92.126 7.31651 93.3221 6.7942 94.9482 5.73202L98 1H90.4598Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.8334 0.224173H99V0H101V0.224173H100.166V2H99.8334V0.224173Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101 0H101.366L101.999 1.6809L102.634 0H103V2H102.747V0.336392H102.741L102.114 2H101.886L101.259 0.336392H101.253V2H101V0Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLmax);
export default __webpack_public_path__ + "static/media/lmax.823d1c3351c4175cf7eedf33117149d2.svg";
export { ForwardRef as ReactComponent };